import { environment } from 'src/environments/environment';

/**
 * LoggerUtil
 * ログ処理。RailgunBaseを経由して、これは直接使わない事。
 */
export const LoggerUtil = (msg: any) => {
		if (! environment.production) {
			console.log(msg);
		}
};
